import Chip from "@mui/material/Chip";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";

const ChipTag = ({ iconSrc, label }) => {
  const colors = useColors();

  return (
    <Chip
      icon={
        <SvgToIcon
          IconLogo={iconSrc}
          width={"20px"}
          style={{
            color: colors.error_dark,
          }}
        />
      }
      label={label}
      style={{
        backgroundColor: colors.error_soft_dark,
        color: colors.error_dark,
        borderRadius: "6px",
        fontSize: "12px",
        height: "24px",
        padding: "8px",
      }}
    />
  );
};

export default ChipTag;
